@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Modern Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-violet-50 to-purple-50 shadow-xl border-b-4 border-violet-200 mb-4 overflow-hidden cstmmrgin"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-violet-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"
    ></div>
  </div>
  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
        </div>
        <div>
          @if (clntDtls && clntDtls.length > 0) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-violet-600 via-purple-600 to-violet-600 bg-clip-text text-transparent mb-0"
          >
            <app-common-header [header_name]="header_label"></app-common-header>
          </h1>
          }
          <p class="text-sm text-gray-500 font-medium mb-1">
            Ward Coverage Analytics
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-3">
      <span class="text-xs text-gray-500 font-medium"
        >Last Refreshed:
        <span class="text-violet-600 font-semibold">{{
          refresh_tm
        }}</span></span
      >
      <div class="flex flex-col min-w-0">
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input"
        ></nz-date-picker>
      </div>
      <button
        (click)="refresh()"
        class="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-violet-500 to-purple-600 hover:from-violet-600 hover:to-purple-700 text-white rounded-lg transition-all duration-200 shadow-sm text-sm font-medium cursor-pointer border-0"
      >
        <span nz-icon nzType="reload" nzTheme="outline"></span>
        Refresh
      </button>
    </div>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-violet-400 via-purple-500 to-violet-500"
  ></div>
</div>

<div class="mx-auto px-3">
  <!-- Summary Strip -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="wcvrg-summary-strip">
    @for (d of tdyCoveredTrips; track d) {
    <div class="wcvrg-summary-item">
      <div class="wcvrg-item-icon bg-violet">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          ></path>
        </svg>
      </div>
      <div class="wcvrg-item-value">
        {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
      </div>
      <div class="wcvrg-item-label">Total Vehicles</div>
    </div>
    }
    <div class="wcvrg-strip-divider"></div>
    @for (d of tdyCoveredTrips; track d) {
    <div class="wcvrg-summary-item">
      <div class="wcvrg-item-icon bg-amber">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          ></path>
        </svg>
      </div>
      <div class="wcvrg-item-value">
        {{ d.TOT_SVM === null ? "0" : d.TOT_SVM }}
      </div>
      <div class="wcvrg-item-label">Total Wards</div>
    </div>
    }
    <div class="wcvrg-strip-divider"></div>
    <div class="wcvrg-summary-item">
      <div class="wcvrg-item-icon bg-emerald">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
          ></path>
        </svg>
      </div>
      <div class="wcvrg-item-value">
        {{ avg_cvrg === null ? 0 : avg_cvrg }}%
      </div>
      <div class="wcvrg-item-label">Avg Coverage</div>
    </div>
  </div>
  }

  <!-- ULB Coverage Table -->
  <div class="wcvrg-section-card">
    <div class="wcvrg-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-violet-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          ></path>
        </svg>
        <h2 class="wcvrg-section-title">ULB Coverage Status</h2>
      </div>
    </div>
    <div class="wcvrg-grid-section">
      <app-data-grid
        [legacyTotalItems]="ttlColumnDefs"
        id="gridContainer"
        style="width: 100%"
        [dataSource]="tripsData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="Zone wise Trip Coverage Status"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="false"
        (cellClick)="devCellclk(columnDefs, $event)"
        [cellPrepared]="bound_onCellPrepared"
      >
      </app-data-grid>
    </div>
  </div>

  <!-- Bottom Row: Chart + Top 10 -->
  <div class="row mt-4">
    <div class="col-lg-6 col-md-6">
      <div class="wcvrg-section-card">
        <div class="wcvrg-section-header">
          <div class="flex items-center gap-2">
            <svg
              class="w-5 h-5 text-purple-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              ></path>
            </svg>
            <h2 class="wcvrg-section-title">Coverage in Last 7 Days</h2>
          </div>
        </div>
        <div id="coverageChart"></div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6">
      <div class="wcvrg-section-card">
        <div class="wcvrg-section-header">
          <div class="flex items-center gap-2">
            <svg
              class="w-5 h-5 text-amber-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              ></path>
            </svg>
            <h2 class="wcvrg-section-title">Zone wise Top Coverages</h2>
          </div>
        </div>
        <div class="wcvrg-grid-section top10-grid">
          <app-data-grid
            id="gridContainer"
            style="width: 100%"
            [dataSource]="toptripsData"
            [legacyColumns]="topTripscolumnDefs"
            [searchPanel]="true"
            [filterRow]="false"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="Zone wise Top 10 Coverages"
            [pageSize]="10"
            [showPageSizeSelector]="false"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="false"
          >
          </app-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>
